import { createMatrix, columnVector, extractColumn } from './matrix.js';

function calculatePrizes({ matrix, stakes }) {

  const resultMatrix = createMatrix(matrix).multiply(columnVector(stakes));
  const result = extractColumn(resultMatrix);

  return result;
}

export function prizes(matrix, stakes) {
  const result = calculatePrizes({ matrix, stakes });
  return result;
}


/*

let stakes0 =  [ 60, 315.7, 385 ];
let matrix0 = [
  [ 1.1099999999999999, -1, -1 ],
  [ 0, 0.55, -0.5 ],
  [ -1, 0.55, 1.08 ]
];

let resultMatrix = prizes(matrix0, stakes0);
console.log("resultMatrix", resultMatrix);
*/